import { z } from "zod";
/**
 * The PAR-Q+ — `GET`/`PUT /me/parq` (`D115`).
 *
 * Seven yes/no questions, the standard readiness screen. `D98` is what this is
 * for: the product ADAPTS, it does not treat, and a positive answer means the
 * app shows a notice recommending medical clearance — it does not diagnose and
 * it does not refuse to train the person.
 */
/** Blueprint §4.2 item 11. Seven, in the questionnaire's own order. */
export const PARQ_QUESTION_COUNT = 7;
/**
 * A TUPLE and not an array of seven.
 *
 * `z.array(z.boolean()).length(7)` accepts the same JSON, but the inferred
 * type is `boolean[]` — so `answers[9]` compiles and `answers[2]` is
 * `boolean | undefined` in a client with `noUncheckedIndexedAccess`. The tuple
 * makes the position a type, which matters because the questions are
 * identified by nothing else: there is no id on the wire, only the order.
 */
export const parqAnswers = z.tuple([
    z.boolean(),
    z.boolean(),
    z.boolean(),
    z.boolean(),
    z.boolean(),
    z.boolean(),
    z.boolean(),
]);
const parqShape = { answers: parqAnswers };
export const parqInput = z.strictObject(parqShape);
export const parqOutput = z.object({
    ...parqShape,
    completedAt: z.iso.datetime(),
    /**
     * Whether the medical-clearance notice was shown for this submission.
     *
     * Server-computed and stored rather than derived by each client from
     * `positiveCount > 0`: the rule for when the notice appears is a `D98`
     * decision, and a second copy of it in the app is the copy that goes stale.
     */
    medicalNoticeShown: z.boolean(),
    /** How many of the seven were `true`. Derived, echoed so no screen counts. */
    positiveCount: z.int().min(0).max(PARQ_QUESTION_COUNT),
});
//# sourceMappingURL=parq.js.map